import { useTheme } from "../../providers/ThemeContext";
import { ReactComponent as WordmarkSvg } from "../../assets/logo/creation-arts-wordmark-light.svg";
import { ReactComponent as WordmarkSvgDark } from "../../assets/logo/creation-arts-wordmark-dark.svg";

type Props = {
  height?: number | string;
  width?: string;
  color?: string;
  isDark?: boolean;
  title?: string;
  className?: any;
  focusable?: boolean;
};

const BrandWordmark = ({
  height = 40,
  width,
  isDark = false,
  title = "Creation Arts wordmark",
  className,
  focusable = false,
}: Props) => {
  const { theme } = useTheme();
  const h = typeof height === "number" ? `${height}px` : height;

  return isDark ? (
    <WordmarkSvgDark
      height={h}
      width={width}
      aria-label={title}
      role="svg"
      className={className}
      focusable={focusable}
      fill="blue"
      preserveAspectRatio="xMinYMid meet"
    />
  ) : (
    <WordmarkSvg
      height={h}
      width={width}
      aria-label={title}
      role="svg"
      className={className}
      focusable={focusable}
      fill="blue"
      preserveAspectRatio="xMinYMid meet"
    />
  );
};

export default BrandWordmark;
